import React from 'react';
import Chip from '@material-ui/core/Chip';
import { FILTER_KEYS, MESSAGE_READ_STATUS } from 'features/message-center/constants';
import strings from 'strings';

import { ChipFilter, ChipFiltersContainer } from './ChipFilters.styled';

export const ChipFilters = ({
  filterParams = { readStatus: MESSAGE_READ_STATUS.all },
  onClickFilter
}) => {
  const handleClickFilter = newParam => {
    onClickFilter(FILTER_KEYS.readStatus, newParam);
  };

  return (
    <ChipFiltersContainer>
      <ChipFilter
        clickable
        color="primary"
        label={strings.shared.ui.all}
        onClick={() => handleClickFilter(MESSAGE_READ_STATUS.all)}
        variant={filterParams.readStatus === MESSAGE_READ_STATUS.all ? 'default' : 'outlined'}
      />
      <Chip
        clickable
        color="primary"
        label={strings.shared.ui.unread}
        onClick={() => handleClickFilter(MESSAGE_READ_STATUS.unread)}
        variant={filterParams.readStatus === MESSAGE_READ_STATUS.unread ? 'default' : 'outlined'}
      />
      <Chip
        clickable
        color="primary"
        label={strings.shared.ui.read}
        onClick={() => handleClickFilter(MESSAGE_READ_STATUS.read)}
        variant={filterParams.readStatus === MESSAGE_READ_STATUS.read ? 'default' : 'outlined'}
      />
    </ChipFiltersContainer>
  );
};
